module.exports = __webpack_public_path__ + "static/media/bensound-allthat.84bf6d59.mp3";